/**
 * トップ
 */
import ResizeObserver from 'resize-observer-polyfill';
import 'intersection-observer';
import 'es6-promise/auto';
import 'picturefill';
import { breakpoint, containerID, assets_path } from '@/_constant/variables';
import {gsap, Cubic} from 'gsap';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
import Vue from 'vue';
import store from '@/_modules/utils/stores';
import loading from '@/_components/loading';
import GlobalHeader from '@/_components/global-header';
import Mv from '@/_components/mv';
import ContactForm from '@/_components/contact-form';

export default class AppVue {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.init();
  }

  /**
   * 初期
   */
  init() {
    this.vue = new Vue({
      components: {
        loading,
        GlobalHeader,
        Mv,
        ContactForm
      },
      data() {
        return {
          isStarted: false,
          current: 0,
          photoMax: 5,
          uiStyle: '',
        }
      },
      el: `#${containerID}`,
      store,
      watch: {},
      computed: {
      },
      created() {
      },
      mounted() {
        this.init();
        this.$nextTick(this.start);
      },
      methods: {
        init() {

        },
        start() {
          if (!window.g5M.isLoaded) {
            setTimeout(this.start, 500);
          } else {
            this.isStarted = true;
            this.$refs['mv'].init();
          }
        },
        setCurrent(num) {
          this.current = num;
        },
        changeSlide(num) {
          this.$refs['mv'].changeSlide(num - 1);
        }
      }
    });
  }
}
